import { createFileRoute } from "@tanstack/react-router";
import AdminLeadDetail from "@/pages/AdminLeadDetail";

export const Route = createFileRoute("/admin/leads/$id")({ component: AdminLeadDetail });
